import { LOGOUT } from "@/components/access/ducks/Actions"
import { SET_CUSTOMER } from "@/components/customer/ducks/Actions"
import {
  RECEIVE_CSV_MAPPING,
  RECEIVE_IMPORTS_HISTORY,
  RECEIVE_INTERNAL_ENRICHMENT_REQUESTS,
  UPDATE_CSV_HEADERS,
  UPDATE_TOTAL_MEMBERS,
} from "@/components/data/internal/ducks/Actions"

const defaultState = {
  openEnrichmentRequests: [],
  closedEnrichmentRequests: [],
  constituentImports: [],
  lastSchoolParams: {},
  csvMapping: {},
  csvHeaders: [],
  totalMembersLoading: false,
}

const internalReducer = (oldState = defaultState, action) => {
  Object.freeze(oldState)
  switch (action.type) {
    case RECEIVE_INTERNAL_ENRICHMENT_REQUESTS:
      return {
        ...oldState,
        openEnrichmentRequests: action.resp.openRequests,
        closedEnrichmentRequests: action.resp.closedRequests,
      }

    case RECEIVE_IMPORTS_HISTORY:
      return {
        ...oldState,
        constituentImports: action.resp.imports,
        lastSchoolParams: action.resp.lastSchoolParams,
      }

    case UPDATE_TOTAL_MEMBERS:
      return {
        ...oldState,
        totalMembersLoading: true,
      }

    case SET_CUSTOMER:
      return {
        ...oldState,
        totalMembersLoading: false,
      }

    case RECEIVE_CSV_MAPPING:
      return {
        ...oldState,
        csvMapping: action.resp,
        csvHeaders: action.resp?.csvHeaders || [],
      }

    case UPDATE_CSV_HEADERS:
      return {
        ...oldState,
        csvHeaders: action.headers,
      }
    case LOGOUT:
      return defaultState

    default:
      return oldState
  }
}

export default internalReducer
